/* FLM — shared UI atoms, ported 1:1 from the prototype (Dating App/flm/ui.jsx).
   Lucide-style line icons @ 1.5px stroke. Accent is orange via --accent tokens. */
import React from 'react';
import { blurFor, blurDataUrl } from '../lib/blur';

const FLM_ICONS = {
  x: ['M18 6 6 18', 'm6 6 12 12'],
  heart: ['M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z'],
  star: ['M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z'],
  zap: ['M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z'],
  flame: ['M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z'],
  mapPin: ['M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0', 'c:12,10,3'],
  message: ['M7.9 20A9 9 0 1 0 4 16.1L2 22Z'],
  user: ['M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2', 'c:12,7,4'],
  activity: ['M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2'],
  chevLeft: ['m15 18-6-6 6-6'],
  chevRight: ['m9 18 6-6-6-6'],
  chevDown: ['m6 9 6 6 6-6'],
  arrowLeft: ['m12 19-7-7 7-7', 'M19 12H5'],
  mic: ['M12 19v3', 'M19 10v2a7 7 0 0 1-14 0v-2', 'M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z'],
  play: ['M6 3 20 12 6 21z'],
  pause: ['M14 4h4v16h-4z', 'M6 4h4v16H6z'],
  badgeCheck: ['M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76', 'm9 12 2 2 4-4'],
  gift: ['M12 8v13', 'M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7', 'M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5', 'r:2,8,20,4,1'],
  video: ['m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5', 'r:2,6,14,12,2'],
  send: ['M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z', 'm21.854 2.147-10.94 10.939'],
  plus: ['M5 12h14', 'M12 5v14'],
  camera: ['M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z', 'c:12,13,3'],
  sliders: ['M21 4h-7', 'M10 4H3', 'M21 12h-9', 'M8 12H3', 'M21 20h-5', 'M12 20H3', 'c:12,4,2', 'c:10,12,2', 'c:14,20,2'],
  globe: ['c:12,12,10', 'M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20', 'M2 12h20'],
  crown: ['M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.735H5.81a1 1 0 0 1-.957-.735L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z', 'M5 21h14'],
  infinity: ['M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.739-8-4.585 0-4.585 8 0 8 5.606 0 7.644-8 12.74-8z'],
  wallet: ['M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1', 'M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4'],
  bell: ['M10.268 21a2 2 0 0 0 3.464 0', 'M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326'],
  lock: ['r:3,11,18,11,2', 'M7 11V7a5 5 0 0 1 10 0v4'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
  rewind: ['M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8', 'M3 3v5h5'],
  copy: ['r:8,8,14,14,2', 'M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2'],
  check: ['M20 6 9 17l-5-5'],
  pencil: ['M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z', 'm15 5 4 4'],
  gem: ['M6 3h12l4 6-10 13L2 9z', 'M11 3 8 9l4 13 4-13-3-6', 'M2 9h20'],
  moreH: ['c:12,12,1', 'c:19,12,1', 'c:5,12,1'],
  search: ['c:11,11,8', 'm21 21-4.3-4.3'],
  /* canvas onboarding icons (ported from Dating App/canvas/flm-ui.jsx `I`) */
  shield: ['M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z', 'm9 12 2 2 4-4'],
  eyeOff: ['M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68', 'M6.61 6.61A13.526 13.526 0 0 0 2 11s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61', 'M14.12 13.12a3 3 0 1 1-4.24-4.24', 'm2 2 20 20'],
  /* filled Telegram plane — render with fill="currentColor" color="none" */
  plane: ['M21.7 2.3a1 1 0 0 0-1.05-.23l-18 7a1 1 0 0 0 .06 1.88l7.6 2.47 2.47 7.6a1 1 0 0 0 1.88.06l7-18a1 1 0 0 0 .04-.78z'],
  rose: ["M12 13c3 0 5-2 5-5 0-1.5-.5-3-1.5-4C14 5.5 12 6 12 6s-2-.5-3.5-2C7.5 5 7 6.5 7 8c0 3 2 5 5 5z","M12 13v8","M9 18c-2.5 0-4-1.5-4.5-3.5C6.5 14.5 9 15 9 18z","M15 18c2.5 0 4-1.5 4.5-3.5C17.5 14.5 15 15 15 18z"],
  calendar: ["r:3,4,18,18,2","M16 2v4","M8 2v4","M3 10h18"],
  ton: ["M4.2 4h15.6c.9 0 1.5 1 1 1.8l-7.8 13.7a1.16 1.16 0 0 1-2 0L3.2 5.8C2.7 5 3.3 4 4.2 4z"],
  qr: ["r:3,3,6,6,1","r:15,3,6,6,1","r:3,15,6,6,1","M15 15h2v2h-2zM19 15h2v2h-2zM15 19h2v2h-2zM19 19h2v2h-2z"],
  champagne: ["M8 22h8","M12 15v7","M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z","M7 10h10"],
  meteor: ["c:7.5,16.5,4.5","m21 3-7.2 7.2","m14 4-2.6 2.6","m20 10-2.6 2.6"],
};

export function Icon({ name, size = 20, color = 'currentColor', strokeWidth = 1.5, fill = 'none', style = {} }) {
  const parts = FLM_ICONS[name] || [];
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={color}
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      style={{ flex: 'none', display: 'block', ...style }} aria-hidden="true">
      {parts.map((p, i) => {
        if (p.startsWith('c:')) {
          const [cx, cy, r] = p.slice(2).split(',').map(Number);
          return <circle key={i} cx={cx} cy={cy} r={r}></circle>;
        }
        if (p.startsWith('r:')) {
          const [x, y, w, h, rx] = p.slice(2).split(',').map(Number);
          return <rect key={i} x={x} y={y} width={w} height={h} rx={rx || 0}></rect>;
        }
        return <path key={i} d={p}></path>;
      })}
    </svg>
  );
}

/* Image that fades in once decoded. loading=lazy + decoding=async keep
   off-screen photos from blocking; it sits over whatever placeholder its
   container provides (gradient, skeleton) so nothing pops in abruptly.
   Cached images that are already complete on mount skip the fade (no flash). */
export function Img({ src, alt = '', className = '', style = {}, eager = false, onLoad, ...rest }) {
  const ref = React.useRef(null);
  const [loaded, setLoaded] = React.useState(false);
  React.useEffect(() => {
    setLoaded(false);
    const el = ref.current;
    if (el && el.complete && el.naturalWidth > 0) setLoaded(true);
  }, [src]);
  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      onLoad={(e) => { setLoaded(true); onLoad?.(e); }}
      className={`flm-img-fade${loaded ? ' is-loaded' : ''}${className ? ' ' + className : ''}`}
      style={style}
      {...rest}
    />
  );
}

/* Gradient photo placeholder — brand-palette gradient + display initial.
   `photo` (absolute URL) swaps the real image in under the same overlays.
   Blur-up: if a BlurHash is known for this photo (passed via `blurHash` or
   resolved from the url→hash registry), a decoded blurry preview shows instantly
   and the full photo fades in over it; with no hash, an animated shimmer covers
   the download instead of a flat gradient. */
export function GradPhoto({ profile, photo, blurHash, w, style = {}, initialSize = '5rem', dim = false, children }) {
  const [c1, c2] = profile.grad;
  const [loaded, setLoaded] = React.useState(false);
  React.useEffect(() => { setLoaded(false); }, [photo]);
  // Blur lookup uses the BASE url (registry key); the <img> may request a smaller
  // resized variant via ?w so thumbnails/avatars don't download the full photo.
  const hash = blurHash ?? blurFor(photo);
  const blur = hash ? blurDataUrl(hash) : null;
  const src = photo && w ? `${photo}${photo.includes('?') ? '&' : '?'}w=${w}` : photo;
  return (
    <div style={{
      position: 'relative', overflow: 'hidden',
      background: `radial-gradient(120% 100% at 30% 0%, ${c1}, ${c2} 75%)`,
      ...style,
    }}>
      {photo && blur ? (
        <img src={blur} alt="" aria-hidden="true" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', transform: 'scale(1.06)', filter: 'blur(2px)' }} />
      ) : null}
      {photo ? <Img src={src} onLoad={() => setLoaded(true)} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} /> : null}
      {/* loading shine over the blur/gradient — a moving light band that signals
          "loading" without hiding the blur-up preview; removed once the photo loads */}
      {photo && !loaded ? <span className="flm-shine" aria-hidden="true" /> : null}
      {photo ? null : <span style={{
        position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: initialSize,
        color: 'rgba(255,255,255,0.14)', userSelect: 'none', letterSpacing: '-0.02em',
      }}>{profile.name[0]}</span>}
      {dim ? <span style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 35%, rgba(0,0,0,0.82) 88%)' }}></span> : null}
      {children}
    </div>
  );
}

/* Round avatar with optional online dot / story ring. Avatars are small, so they
   request a 256px resized variant by default (never the full-res photo). */
export function Avatar({ profile, photo, size = 48, ring = false, onClick, w = 256 }) {
  return (
    <div onClick={onClick} style={{
      position: 'relative', width: size, height: size, flex: 'none',
      borderRadius: '50%', cursor: onClick ? 'pointer' : 'default',
      padding: ring ? 2 : 0,
      background: ring ? 'linear-gradient(135deg, var(--accent), var(--primary-light))' : 'none',
    }}>
      <GradPhoto profile={profile} photo={photo} w={w} initialSize={size * 0.42 + 'px'}
        style={{ width: '100%', height: '100%', borderRadius: '50%', border: ring ? '2px solid #000' : '1px solid var(--border-bright)' }} />
      {profile.online ? <span className="accent-dot" style={{ position: 'absolute', bottom: 1, insetInlineEnd: 1, width: 9, height: 9, border: '2px solid #000' }}></span> : null}
    </div>
  );
}

export function VerifiedMark({ size = 16 }) {
  return <Icon name="badgeCheck" size={size} color="var(--accent)" />;
}

/* Mono micro-label, e.g. "2.4 KM" */
export function MonoLabel({ children, color = 'var(--text-secondary)', size = '0.68rem', style = {} }) {
  return <span style={{
    fontFamily: 'var(--font-mono)', fontWeight: 500, fontSize: size,
    letterSpacing: '0.08em', textTransform: 'uppercase', color, ...style,
  }}>{children}</span>;
}

/* Interest chip */
export function Chip({ children, active = false, onClick, small = false }) {
  return (
    <button onClick={onClick} className="flm-chip" style={{
      display: 'inline-flex', alignItems: 'center', gap: '0.4em',
      padding: small ? '0.32em 0.8em' : '0.5em 1em',
      borderRadius: 'var(--radius-pill)', cursor: onClick ? 'pointer' : 'default',
      fontFamily: 'var(--font-body)', fontWeight: 500, fontSize: small ? '0.8rem' : '0.92rem',
      border: active ? '1px solid rgba(255,212,145,0.45)' : '1px solid var(--border-bright)',
      background: active ? 'var(--accent-tint)' : 'var(--surface-elevated)',
      color: active ? 'var(--accent)' : 'var(--text-secondary)',
      transition: 'all 0.2s var(--ease-out-expo)',
    }}>{children}</button>
  );
}

/* Telegram Mini-App chrome bar (kept for parity; Telegram supplies real chrome) */
export function TGChrome({ title = 'FLM', onClose }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '6px 14px 6px', flex: 'none',
    }}>
      <button className="flm-ghost-btn" onClick={onClose} style={{ color: 'var(--text-muted)' }}>
        <Icon name="x" size={16} />
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span className="accent-dot" style={{ width: 6, height: 6 }}></span>
        <MonoLabel color="var(--text-muted)" size="0.62rem">{title} · MINI APP</MonoLabel>
      </div>
      <button className="flm-ghost-btn" style={{ color: 'var(--text-muted)' }}>
        <Icon name="moreH" size={16} />
      </button>
    </div>
  );
}

/* Bottom navigation. Pulse (feed) is hidden for now — kept here behind the flag
   so it can return without rewiring. Tabs render evenly across however many are
   visible, so 4 tabs space themselves correctly. */
export const PULSE_ENABLED = false;

export function BottomNav({ tab, setTab, t, unread = 0 }) {
  const items = [
    { id: 'discover', icon: 'flame', label: t('discover') },
    { id: 'feed', icon: 'activity', label: t('pulse'), enabled: PULSE_ENABLED },
    { id: 'map', icon: 'mapPin', label: t('nearby') },
    { id: 'chats', icon: 'message', label: t('chats'), badge: unread },
    { id: 'profile', icon: 'user', label: t('profile') },
  ].filter((it) => it.enabled !== false);
  return (
    <nav style={{
      display: 'grid', gridTemplateColumns: `repeat(${items.length}, 1fr)`, flex: 'none',
      borderTop: '1px solid var(--border)', background: 'rgba(0,0,0,0.85)',
      backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
      padding: '10px 6px max(22px, var(--safe-bottom))',
    }}>
      {items.map((it) => {
        const active = tab === it.id;
        return (
          <button key={it.id} onClick={() => setTab(it.id)} className="flm-ghost-btn flm-press" aria-label={it.label}
            aria-current={active ? 'page' : undefined} style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
            padding: '4px 0', position: 'relative',
            color: active ? 'var(--accent)' : 'var(--text-muted)',
            transition: 'color 0.2s ease',
          }}>
            <span style={{
              position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center',
              width: 44, height: 30, borderRadius: 12,
              background: active ? 'var(--accent-tint)' : 'transparent',
              transition: 'background 0.2s ease',
            }}>
              <Icon name={it.icon} size={22} strokeWidth={active ? 2.2 : 1.5} />
              {it.badge ? <span style={{
                position: 'absolute', top: -3, insetInlineEnd: 2,
                minWidth: 15, height: 15, borderRadius: 8, padding: '0 4px',
                background: 'var(--accent)', color: '#000',
                fontFamily: 'var(--font-mono)', fontSize: '0.58rem', fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                border: '1.5px solid #000',
              }}>{it.badge > 99 ? '99+' : it.badge}</span> : null}
            </span>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.55rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
              {it.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}

/* Screen header inside the app */
export function ScreenHead({ title, trailing, leading }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '10px 18px 12px', flex: 'none', gap: 10,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
        {leading}
        <h1 style={{
          fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.55rem',
          letterSpacing: '-0.02em', color: 'var(--text)', margin: 0, whiteSpace: 'nowrap',
        }}>{title}</h1>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{trailing}</div>
    </div>
  );
}

/* Small round icon button */
export function RoundBtn({ icon, onClick, size = 38, color = 'var(--text-secondary)', border = true, bg = 'var(--surface-elevated)', iconSize, style = {}, glow = false }) {
  return (
    <button onClick={onClick} className="flm-round-btn flm-press" style={{
      width: size, height: size, borderRadius: '50%', cursor: 'pointer',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none',
      border: border ? '1px solid var(--border-bright)' : 'none',
      background: bg, color,
      boxShadow: glow ? 'var(--glow-accent)' : 'none',
      transition: 'transform 0.2s var(--ease-spring), box-shadow 0.2s ease',
      ...style,
    }}>
      <Icon name={icon} size={iconSize || size * 0.48} />
    </button>
  );
}

/* Bottom sheet with backdrop */
export function Sheet({ open, onClose, children, height = 'auto', pad = true }) {
  if (!open) return null;
  return (
    <div style={{ position: 'absolute', inset: 0, zIndex: 60, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)', animation: 'flmFadeIn 0.25s var(--ease-out-expo)' }}></div>
      <div style={{
        position: 'relative', background: 'var(--surface)', borderTop: '1px solid var(--border-bright)',
        borderRadius: 'var(--radius-2xl) var(--radius-2xl) 0 0', maxHeight: '88%', height,
        display: 'flex', flexDirection: 'column', animation: 'flmSlideUp 0.35s var(--ease-out-expo)',
        boxShadow: '0 -30px 70px -25px rgba(0,0,0,0.9)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 2px', flex: 'none' }}>
          <span style={{ width: 38, height: 4, borderRadius: 2, background: 'var(--border-bright)' }}></span>
        </div>
        <div style={{ overflowY: 'auto', padding: pad ? '12px 20px 28px' : 0, flex: 1 }}>{children}</div>
      </div>
    </div>
  );
}

/* Full-screen overlay inside the app */
export function FullOverlay({ open, children, z = 70, bg = '#000' }) {
  if (!open) return null;
  return (
    <div style={{ position: 'absolute', inset: 0, zIndex: z, background: bg, display: 'flex', flexDirection: 'column', animation: 'flmFadeIn 0.3s var(--ease-out-expo)', overflow: 'hidden' }}>
      {children}
    </div>
  );
}

/* TON price tag */
export function TonTag({ amount, size = '0.8rem', color = 'var(--accent)' }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35em', fontFamily: 'var(--font-mono)', fontWeight: 600, fontSize: size, color }}>
      <Icon name="gem" size={parseFloat(size) * 16} color={color} />
      {amount}&nbsp;TON
    </span>
  );
}

/* Animated voice waveform (decorative) */
export function VoiceWave({ playing = false, bars = 24, color = 'var(--accent)', height = 26 }) {
  const hs = [0.4, 0.7, 1, 0.55, 0.85, 0.35, 0.95, 0.6, 0.8, 0.45, 1, 0.7, 0.5, 0.9, 0.4, 0.75, 1, 0.55, 0.65, 0.9, 0.35, 0.8, 0.6, 0.45];
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2, height }}>
      {Array.from({ length: bars }).map((_, i) => (
        <span key={i} style={{
          width: 2.5, borderRadius: 2, background: color, flex: 'none',
          height: hs[i % hs.length] * height,
          opacity: playing ? 1 : 0.45,
          animation: playing ? `flmWave 0.9s ease-in-out ${i * 0.05}s infinite alternate` : 'none',
          transformOrigin: 'center',
        }}></span>
      ))}
    </div>
  );
}

/* ---- Studio Chronos DS components used by the screens ---- */

/* Primary/outline CTA (replaces window.StudioChronosDesignSystem.Button) */
export function Button({ variant = 'primary', children, onClick, disabled = false, style = {} }) {
  return (
    <button onClick={onClick} disabled={disabled}
      className={`${variant === 'primary' ? 'cta-primary' : 'cta-outline'} flm-press`}
      style={{ opacity: disabled ? 0.35 : 1, pointerEvents: disabled ? 'none' : 'auto', ...style }}>
      {children}
    </button>
  );
}

/* Small mono tag (replaces window.StudioChronosDesignSystem.Badge).
   Tones: neutral (hairline), accent (orange), purple (brand). */
export function Badge({ tone = 'neutral', children, className = '', style = {}, ...rest }) {
  const tones = {
    neutral: {
      border: '1px solid var(--border-bright)',
      background: 'var(--surface-elevated)',
      color: 'var(--text-secondary)',
    },
    accent: {
      border: '1px solid rgba(255,212,145,0.45)',
      background: 'var(--accent-tint)',
      color: 'var(--accent)',
    },
    purple: {
      border: '1px solid var(--primary-light)',
      background: 'var(--primary-tint)',
      color: 'var(--accent)',
    },
  };
  return (
    <span className={className} style={{
      display: 'inline-flex', alignItems: 'center', gap: '0.4em',
      padding: '0.3em 0.7em', borderRadius: 'var(--radius-pill)',
      fontFamily: 'var(--font-mono)', fontWeight: 500, fontSize: '0.68rem',
      letterSpacing: '0.04em', ...tones[tone], ...style,
    }} {...rest}>{children}</span>
  );
}

/* Pricing/offer tile (replaces window.StudioChronosDesignSystem.OfferCard).
   `featured` adds accent border tint + purple halo (.offer-card.featured in tokens.css). */
export function OfferCard({ eyebrow, title, price, priceNote, features = [], cta, featured = false, className = '', style = {}, ...rest }) {
  return (
    <div className={`offer-card ${featured ? 'featured' : ''} ${className}`} style={style} {...rest}>
      {eyebrow ? (
        <span className="eyebrow" style={{ marginBottom: '1rem' }}>
          {featured ? <span className="accent-dot"></span> : null}
          {eyebrow}
        </span>
      ) : null}
      {title ? <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.5rem', color: 'var(--text)', marginTop: eyebrow ? '0.75rem' : 0 }}>{title}</h3> : null}
      {price ? (
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', margin: '1rem 0 0.25rem' }}>
          <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, fontSize: '2.2rem', color: featured ? 'var(--accent)' : 'var(--text)' }}>{price}</span>
          {priceNote ? <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8rem', color: 'var(--text-muted)' }}>{priceNote}</span> : null}
        </div>
      ) : null}
      {features.length ? (
        <ul style={{ listStyle: 'none', padding: 0, margin: '1.5rem 0 0', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
          {features.map((f, i) => (
            <li key={i} style={{ display: 'flex', gap: '0.6rem', alignItems: 'flex-start', fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', fontSize: '1rem' }}>
              <span className="accent-dot" style={{ marginTop: '0.5em' }}></span>
              <span>{f}</span>
            </li>
          ))}
        </ul>
      ) : null}
      {cta ? <div style={{ marginTop: '1.75rem' }}>{cta}</div> : null}
    </div>
  );
}

export function Eyebrow({ children, style = {} }) {
  return (
    <span className="eyebrow" style={style}>
      <span className="accent-dot" style={{ width: 7, height: 7 }}></span>
      {children}
    </span>
  );
}

/* Ambient glow blob (from onboarding.jsx) */
export function GlowBlob({ color = 'is-purple', size = 280, x = '50%', y = '50%', o = 1 }) {
  return <span className={`radial-glow ${color}`} style={{ width: size, height: size, left: x, top: y, transform: 'translate(-50%,-50%)', opacity: o }}></span>;
}

/* Photo upload slot (replaces the prototype's <image-slot> custom element).
   `preview` (object/absolute URL) shows the picked photo inside the same slot.
   Optional `onDelete` adds an ✕ badge over a filled slot (tapping the slot
   itself still re-picks); without it the original single-button render stands. */
/* One-shot spinner keyframes for the photo-check overlay (own their CSS, like
   SparkBurst, so tokens.css stays untouched). prefers-reduced-motion in tokens.css
   targets `*`, so the spin collapses to ~0ms for users who asked for it. */
let _photoStatusCssInjected = false;
function ensurePhotoStatusCss() {
  if (_photoStatusCssInjected || typeof document === 'undefined') return;
  _photoStatusCssInjected = true;
  const el = document.createElement('style');
  el.textContent =
    '@keyframes flm-photo-spin{to{transform:rotate(360deg)}}' +
    '.flm-photo-spin{width:22px;height:22px;border-radius:50%;border:2.5px solid rgba(255,255,255,0.25);border-top-color:var(--accent);animation:flm-photo-spin .8s linear infinite}';
  document.head.appendChild(el);
}

/* `status`: 'checking' (AI moderation in flight) | 'ok' (passed) | 'error'
   (rejected). Drives an overlay + a colored ring so the user sees per-photo
   progress and result. `statusLabel` is the short text shown while checking. */
export function PhotoSlot({ placeholder = 'Photo', style = {}, onPick, preview, onDelete, status, statusLabel }) {
  ensurePhotoStatusCss();
  const ring =
    status === 'ok' ? '0 0 0 2px var(--accent)' :
    status === 'error' ? '0 0 0 2px var(--love)' : 'none';
  const slotStyle = {
    position: 'relative', overflow: 'hidden',
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8,
    border: '1px dashed var(--border-bright)', background: 'var(--surface-elevated)',
    color: 'var(--text-secondary)', borderRadius: 16, cursor: 'pointer',
    fontFamily: 'var(--font-body)', fontSize: '0.85rem',
  };
  const inner = (
    <>
      <Icon name="camera" size={22} />
      {placeholder}
      {preview ? <img src={preview} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} /> : null}
    </>
  );
  /* Overlay: spinner+label while checking, a colored result badge after. */
  const overlay = !status ? null : status === 'checking' ? (
    <div style={{
      position: 'absolute', inset: 0, zIndex: 3, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 8, pointerEvents: 'none',
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(1px)', WebkitBackdropFilter: 'blur(1px)',
    }}>
      <span className="flm-photo-spin" />
      <span className="flm-mono" style={{ fontSize: 8.5, color: '#fff', textAlign: 'center', padding: '0 6px' }}>{statusLabel || 'Checking…'}</span>
    </div>
  ) : (
    <span style={{
      position: 'absolute', insetInlineStart: 6, top: 6, zIndex: 3, width: 22, height: 22, borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none',
      background: status === 'ok' ? 'var(--accent)' : 'var(--love)', color: '#000',
    }}>
      <Icon name={status === 'ok' ? 'check' : 'x'} size={13} strokeWidth={3} color="#000" />
    </span>
  );
  if (!onDelete) {
    return <button onClick={onPick} className="flm-ghost-btn" style={{ ...slotStyle, ...style }}>{inner}</button>;
  }
  /* delete needs its own button — buttons can't nest, so wrap in a div */
  return (
    <div style={{ position: 'relative', borderRadius: 16, boxShadow: ring, ...style }}>
      <button onClick={onPick} className="flm-ghost-btn"
        style={{ ...slotStyle, position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
        {inner}
      </button>
      {overlay}
      {preview ? (
        <button onClick={(e) => { e.stopPropagation(); onDelete(); }} className="flm-ghost-btn" aria-label="Remove photo"
          style={{
            position: 'absolute', top: 6, insetInlineEnd: 6, zIndex: 4, width: 24, height: 24, padding: 0,
            borderRadius: '50%', background: 'rgba(0,0,0,0.65)', border: '1px solid var(--border-bright)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text)',
            backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)',
          }}>
          <Icon name="x" size={12} strokeWidth={2} />
        </button>
      ) : null}
    </div>
  );
}

/* ---------- SparkBurst — super-like celebratory burst (additive) ----------
   A brief, on-brand (love/pink + accent) radial burst that reads as "bigger than
   a like": an expanding pink ring shockwave + a starburst of lightning-spark
   shards firing outward from the center, with a soft glow flash. Pure CSS/SVG,
   no deps. ~600ms one-shot. Render it absolutely-positioned over the spark
   origin (card center / Spark button) and unmount it on completion.

   The keyframes live in a once-injected <style> tag (this component owns them,
   keeping tokens.css untouched). The global prefers-reduced-motion reset in
   tokens.css targets `*`, so it collapses these animations to ~0ms for free —
   the burst simply doesn't play for users who asked for reduced motion. */
let _sparkCssInjected = false;
function ensureSparkCss() {
  if (_sparkCssInjected || typeof document === 'undefined') return;
  _sparkCssInjected = true;
  const css = `
@keyframes flmSparkRing {
  0%   { transform: translate(-50%, -50%) scale(0.2); opacity: 0.9; }
  100% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }
}
@keyframes flmSparkRing2 {
  0%   { transform: translate(-50%, -50%) scale(0.2); opacity: 0.7; }
  60%  { opacity: 0.5; }
  100% { transform: translate(-50%, -50%) scale(3.2); opacity: 0; }
}
@keyframes flmSparkFlash {
  0%   { transform: translate(-50%, -50%) scale(0.4); opacity: 0; }
  25%  { opacity: 0.85; }
  100% { transform: translate(-50%, -50%) scale(1.7); opacity: 0; }
}
@keyframes flmSparkShard {
  0%   { transform: translate(-50%, -50%) rotate(var(--ang)) translateY(0) scale(0.4); opacity: 0; }
  18%  { opacity: 1; }
  100% { transform: translate(-50%, -50%) rotate(var(--ang)) translateY(calc(-1 * var(--dist))) scale(1); opacity: 0; }
}`;
  const el = document.createElement('style');
  el.setAttribute('data-flm', 'spark-burst');
  el.textContent = css;
  document.head.appendChild(el);
}

export function SparkBurst({ size = 200, color = 'var(--love)', accent = 'var(--accent)' }) {
  ensureSparkCss();
  // 12 lightning shards fanned evenly around the circle (alternating love/accent
  // + alternating throw distance) so the burst reads dense and energetic.
  const shards = Array.from({ length: 12 });
  return (
    <span aria-hidden="true" style={{
      position: 'absolute', left: '50%', top: '50%', width: size, height: size,
      transform: 'translate(-50%, -50%)', pointerEvents: 'none', zIndex: 20,
    }}>
      {/* central glow flash */}
      <span style={{
        position: 'absolute', left: '50%', top: '50%', width: size * 0.55, height: size * 0.55,
        borderRadius: '50%',
        background: `radial-gradient(circle, ${color} 0%, oklch(0.71 0.2 354 / 0.35) 40%, transparent 70%)`,
        animation: 'flmSparkFlash 0.55s var(--ease-out-expo) forwards',
      }}></span>
      {/* expanding ring shockwaves (pink, then a slower accent halo) */}
      <span style={{
        position: 'absolute', left: '50%', top: '50%', width: size * 0.45, height: size * 0.45,
        borderRadius: '50%', border: `2.5px solid ${color}`,
        boxShadow: '0 0 18px oklch(0.71 0.2 354 / 0.8)',
        animation: 'flmSparkRing 0.6s var(--ease-out-expo) forwards',
      }}></span>
      <span style={{
        position: 'absolute', left: '50%', top: '50%', width: size * 0.45, height: size * 0.45,
        borderRadius: '50%', border: `1.5px solid ${accent}`,
        animation: 'flmSparkRing2 0.68s var(--ease-out-expo) 0.04s forwards',
      }}></span>
      {/* lightning shards firing outward */}
      {shards.map((_, i) => {
        const ang = (360 / shards.length) * i;
        const dist = size * (i % 2 ? 0.34 : 0.46);
        const c = i % 2 ? accent : color;
        return (
          <span key={i} style={{
            position: 'absolute', left: '50%', top: '50%',
            width: 3, height: i % 2 ? 12 : 16, borderRadius: 2, background: c,
            boxShadow: `0 0 8px ${c}`,
            transformOrigin: 'center',
            // CSS custom props drive the per-shard angle + throw distance
            '--ang': `${ang}deg`, '--dist': `${dist}px`,
            animation: `flmSparkShard 0.62s var(--ease-out-expo) forwards`,
          }}></span>
        );
      })}
    </span>
  );
}
